import { observer } from "mobx-react-lite";
import React from "react";
import { ChildEntitiesButton } from "src/common/attrEdit/components";
import { t } from "i18next";
import { Button, Dropdown, Space } from "antd";
import { ItemType, MenuItemType } from "antd/es/menu/hooks/useItems";
import { DownOutlined } from "@ant-design/icons";
import { ChildEntsCreate } from "./ChildEntsCreate";
import { ChildEntitiesStore } from "../ChildEntitiesStore";
import { ChildEntsAssign } from "./ChildEntsAssign";

interface PropsChildEntitiesCreators {
  store: ChildEntitiesStore;
  disabled?: boolean;
}

export const ChildEntitiesCreators: React.FC<PropsChildEntitiesCreators> =
  observer(({ store, disabled }) => {
    const { buttons, assignStore, isDropdownView, currObjName } = store;
    const creatorsMap: Record<ChildEntitiesButton, MenuItemType> = {
      [ChildEntitiesButton.create]: {
        key: "create",
        label: <ChildEntsCreate store={store} disabled={disabled} />,
      },

      [ChildEntitiesButton.assign]: {
        key: "assign",
        label: (
          <ChildEntsAssign
            store={assignStore}
            isDropdownView={isDropdownView}
            disabled={disabled}
            currObjName={currObjName}
          />
        ),
      },
    };
    const menuItems = buttons
      .map((button) => [creatorsMap[button], { type: "divider" } as ItemType])
      .flat();
    menuItems.pop();

    return isDropdownView ? (
      <Dropdown
        menu={{ items: menuItems }}
        placement="bottomRight"
        disabled={disabled}
      >
        <Button id="childEntsCreators" type="primary">
          <Space>
            {t("Create")}
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown>
    ) : (
      buttons[0] && creatorsMap[buttons[0]].label
    );
  });
